import userConstants from "./userConstants";
import navigationConstants from "./navigationConstants";

const constant = { navigationConstants, userConstants };
export default constant;
